module.exports = __webpack_public_path__ + "static/media/waterproof-chair.18ba3c05.png";